import React from "react";
import Box from "@material-ui/core/Box";
import {
	MuiPickersUtilsProvider,
	KeyboardTimePicker
} from "@material-ui/pickers";
import ScheduleIcon from "@material-ui/icons/Schedule";
import DateFnsUtils from "@date-io/date-fns";
import { isValid, parseISO } from "date-fns";
import timePickerStyles from "../styles/TimePicker.styles";

const ClockTimePicker = ({ label, value, handleTimeChange = () => {} }) => {
	const classes = timePickerStyles();

	return (
		<MuiPickersUtilsProvider utils={DateFnsUtils}>
			<Box className={classes.clockTimePickerBox}>
				<KeyboardTimePicker
					fullWidth
					keyboardIcon={<ScheduleIcon />}
					DialogProps={{ className: classes.clockTimePicker }}
					margin="normal"
					id="clock-time-picker"
					label={label}
					value={parseISO(value)}
					onChange={(date) => {
						if (isValid(date)) {
							handleTimeChange(date.toISOString());
						}
					}}
					KeyboardButtonProps={{
						"aria-label": "change time"
					}}
				/>
			</Box>
		</MuiPickersUtilsProvider>
	);
};

export default ClockTimePicker;
